import logo from './logo.svg';
import './App.css';
import Game from "./Game";
import Booth from "./Booth";
import Invitation from "./Invitation";
// import Poll from "./Poll";

import React, { useState, useEffect, ChangeEventHandler, ChangeEvent, SyntheticEvent, KeyboardEvent, createContext } from "react";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Slider from '@mui/material/Slider';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Icon from '@mui/material/Icon';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import {Route, Routes, Link, useParams, useNavigate} from 'react-router-dom';

import axios from 'axios';
import { Buffer } from 'buffer';
// import { type } from 'os';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
      <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const pages = [
  { id: 0, name: "Home"},
  { id: 1, name: "Invitation"},
  { id: 2, name: "Game"},
  { id: 3, name: "Booth"}
];

function App() {

  return (
    <div>
      <header className="App-header">
      </header>
      
      <Routes>
        {/* <Route path="/home" element={<Home />} /> */}

        {/* <Route path="/home/:userId" element={<Home/>} /> */}
        <Route path="/game/:userId" element={<Game />} />
        {/* <Route path="/" element={<Booth />} /> */}
        <Route path="/booth/:userId" element={<Booth />} />
        <Route path="/invitation/:userId" element={<Invitation />} />

        {/* <Route path="/home/:userId/:mode" element={<Home />} /> */}
        <Route path="/game/:userId/:mode" element={<Game />} />
        <Route path="/booth/:userId/:mode" element={<Booth />} />
        <Route path="/invitation/:userId/:mode" element={<Invitation />} />
      </Routes>

    </div>
  );
}

export default App;


function Home() {
  const navigate = useNavigate();
  const { userId, mode } = useParams();

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);

    // Append available parameters to URL
    var args = "";
    if (typeof userId != 'undefined') {
      args = "/"+userId;
      if (typeof mode != 'undefined') {
        args += "/"+mode;
      }
    }
    
    navigate("/"+pages[newValue].name.toLowerCase()+args);
  };
  
  return (
    <div>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          {pages.map(page => {
            return (
              <Tab label={page.name} {...a11yProps(page.id)} key={page.id}></Tab>
            )
          })}
        </Tabs>
      </Box>
    </div>
  );
}